import { checkTimeordate } from '../types'
import mtz from '../utils/mtz'

export default function makeGetYear(context = {}) {
  const { timezone }: any = context

  return (timeordate: string) => {
    checkTimeordate(timeordate)
    return mtz(timeordate, timezone).year()
  }
}
